import { render, staticRenderFns } from "./UmppManifest.vue?vue&type=template&id=054a6b42&scoped=true&"
import script from "./UmppManifest.vue?vue&type=script&lang=js&"
export * from "./UmppManifest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054a6b42",
  null
  
)

export default component.exports